import React from 'react';
import {
    Slider as NativeSlider,
    ISliderProps,
    Box,
} from 'native-base';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@springbig/shared';
import { SpIcon } from './Icon';
import { Caption } from './Typography';

export type DefaultValuesPointsProps = {
    value: number;
    label: string;
    divisbleValue?: number;
};

export interface SliderProps extends ISliderProps {
    defaultValue?: number;
    valuePoints?: DefaultValuesPointsProps[];
    dots?: boolean;
    maxValue?: number;
}

const SliderBar = ({
    dots,
    valuePoints,
    defaultValue,
    maxValue
}: SliderProps) => {

    const {
        primary,
        background_secondary,
    } = useTheme();

    const logicCalculateColor = (value: number) => {

        if (defaultValue && defaultValue >= value) {
            return primary;
        }

        return background_secondary;
    };

    return (
        <Box w={'80%'}>
            {
                defaultValue >= 0 && (
                    <Slider defaultValue={defaultValue} maxValue={maxValue} />
                )
            }
            { dots && valuePoints && valuePoints.length > 0 && valuePoints.map((point, index) => {

                const divisor = point.divisbleValue ? point.divisbleValue : 1;
                return (
                    <Box key={index} position={'absolute'} top={'30%'} left={`${divisor * 97}%`}>
                        <SpIcon
                            color={logicCalculateColor(point.value)}
                            icon={faCircle}
                            size={10}
                        />
                        <Caption
                            textAlign={'center'}
                            fontSize={12}
                        >
                            { point.label }
                        </Caption>
                    </Box>
                );
            })}
        </Box>
    );
};

const Slider = ({ defaultValue, maxValue }: SliderProps) => {

    const {
        primary,
        background_secondary,
        radius_sm,
    } = useTheme();

    return (
        <NativeSlider
            isReadOnly={true}
            bg={'transparent'}
            defaultValue={defaultValue}
            maxValue={maxValue}
            size={'lg'}
        >
            <NativeSlider.Track
                rounded={radius_sm}
                bg={maxValue > 0 ? background_secondary : primary}
            >
                <NativeSlider.FilledTrack
                    bg={primary}
                />
            </NativeSlider.Track>
        </NativeSlider>
    );
};

export default SliderBar;

